import script from "./SubmissionSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmissionSection.vue?vue&type=script&setup=true&lang=js"

import "./SubmissionSection.vue?vue&type=style&index=0&id=7d2f92ac&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d2f92ac"]])

export default __exports__